import { render, staticRenderFns } from "./LatihanFinal1.vue?vue&type=template&id=53d65702&scoped=true"
import script from "./LatihanFinal1.vue?vue&type=script&lang=js"
export * from "./LatihanFinal1.vue?vue&type=script&lang=js"
import style0 from "./LatihanFinal1.vue?vue&type=style&index=0&id=53d65702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d65702",
  null
  
)

export default component.exports